package fyi.moko.hotpl.domain.usecase

import fyi.moko.hotpl.data.backup.LocalBackupManager
import fyi.moko.hotpl.data.backup.PreparedHotplBackup

class PrepareImportBackupUseCase(
    private val backupManager: LocalBackupManager,
) {
    suspend operator fun invoke(json: String): PreparedHotplBackup = backupManager.prepareImport(json)
}